const empty = (len = 4) => {
  let arr = new Array(len).fill('\xa0')
  return arr.join('')
}
const empty6 = empty(6)
const empty12 = empty(12)
const emptyTitle = empty(4)

const replaceVariable = function(temp, option) {
  let result = temp,
    t = /(#)([^#]+)(#)/.exec(temp)
  if (t && t.length) {
    let key = t[2]
    let res = (key && option[key]) || `$${key}$`
    result = result.replace(t[0], res)
    // console.log('replaceVariable', result)
    result = replaceVariable(result, option)
  }
  return result
}
let getWordContentFn = (contractTemp, option = {}) => {
  return contractTemp.map(item => {
    const title = item.title || ''
    let word = []
    if (typeof item.word === 'string') {
      item.word = replaceVariable(item.word, option)
      word.push({ empty: empty6, content: item.word })
    } else if (Array.isArray(item.word)) {
      let wordTemp = []
      for (let index = 0; index < item.word.length; index++) {
        let wordItem = item.word[index]
        if (typeof wordItem === 'string') {
          wordItem = replaceVariable(wordItem, option)
          wordTemp.push({ empty: empty6, content: wordItem })
        } else if (Array.isArray(wordItem)) {
          for (let j = 0; j < wordItem.length; j++) {
            if (typeof wordItem[j] === 'string') {
              let tempWord = replaceVariable(wordItem[j], option)
              wordTemp.push({ empty: empty12, dot: true, content: tempWord })
            }
          }
        } else {
          wordItem && wordTemp.push(wordItem)
        }
      }
      word = wordTemp
    }
    return { title, word }
  })
}

export { empty6, empty12, emptyTitle, empty, getWordContentFn }
